import React from 'react';
import PayrollChannelPresentational from './payroll-channel-presentational';

const PayrollChannelFunctional = () => {
	return <PayrollChannelPresentational />;
};

export default PayrollChannelFunctional;
